"use strict";
import Splide from "@splidejs/splide";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const slider = document.querySelector(".o-testimonials__cards.splide");

        if (!slider) return;

        const splide = new Splide(slider, {
            type: "loop",
            autoplay: true,
            perPage: 3,
            gap: "16px",
            arrows: true,
            pagination: false,
            perMove: 1,
            breakpoints: {
                768: {
                    perPage: 1,
                },
            },
        });
        const bar = splide.root.querySelector(".my-slider-progress-bar");
        splide.on("mounted move", function () {
            const end = splide.Components.Controller.getEnd() + 1;
            const rate = Math.min((splide.index + 1) / end, 1);
            bar.style.width = String(100 * rate) + "%";
        });

        splide.mount();

        /* Ver Mais  */
        (function () {
            const MAX = 476;

            document
                .querySelectorAll(".js-testimonial")
                .forEach((container) => {
                    const btn = container.parentElement.querySelector(
                        ".js-testimonial-toggle"
                    );
                    if (!btn) return;

                    // Se não tiver mais que 375 caracteres (texto puro), não faz nada e mantém botão escondido
                    const fullTextLen = (container.textContent || "").trim()
                        .length;
                    if (fullTextLen <= MAX) return;

                    // Achar o ponto de corte em text nodes (preserva HTML)
                    let count = 0;
                    let targetNode = null;
                    let offset = 0;

                    const walker = document.createTreeWalker(
                        container,
                        NodeFilter.SHOW_TEXT,
                        null,
                        false
                    );

                    while (walker.nextNode()) {
                        const node = walker.currentNode;
                        const len = node.nodeValue.length;

                        if (count + len >= MAX) {
                            targetNode = node;
                            offset = MAX - count;
                            break;
                        }
                        count += len;
                    }

                    if (!targetNode) return;

                    // Divide o textNode no ponto exato (não quebra HTML)
                    const restNode = targetNode.splitText(offset);

                    // Range do restante até o fim do container
                    const range = document.createRange();
                    range.setStart(restNode, 0);

                    const endNode = container.lastChild;
                    if (endNode) range.setEndAfter(endNode);

                    const hiddenFragment = range.extractContents();

                    // "..." visível somente quando fechado
                    const dots = document.createElement("span");
                    dots.className = "testimonial-dots";
                    dots.textContent = "...";

                    // Conteúdo oculto
                    const hidden = document.createElement("span");
                    hidden.className = "testimonial-hidden";
                    hidden.hidden = true;
                    hidden.appendChild(hiddenFragment);

                    container.appendChild(dots);
                    container.appendChild(hidden);

                    // Mostrar botão
                    btn.hidden = false;

                    // Toggle
                    btn.addEventListener("click", () => {
                        const isOpen = !hidden.hidden;

                        hidden.hidden = isOpen;
                        dots.hidden = !isOpen;

                        btn.textContent = isOpen
                            ? btn.dataset.more
                            : btn.dataset.less;
                        btn.setAttribute("aria-expanded", String(!isOpen));
                    });
                });
        })();
    });
}
